"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractWithoutStoreSchema = exports.ContractSchema = exports.pixQRCodeSchema = exports.slipSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.slipSchema = zod_1.z.object({
    slipDownloadUrl: zod_1.z.string(),
    slipNumber: zod_1.z.string(),
    slipExpirationDate: zod_1.z.coerce.date(),
});
exports.pixQRCodeSchema = zod_1.z.object({
    code: zod_1.z.string(),
    qrCodeUrl: zod_1.z.string(),
    expirationDate: zod_1.z.coerce.date(),
    /**
     * @description URL to the hosted instructions page for the payment intent
     */
    qrCodeHostedInstructionsUrl: zod_1.z.string().optional(),
});
exports.ContractSchema = _1.PlanSchema.extend({
    store: zod_1.z.lazy(() => __1.BaseStoreSchema.partial().required({ id: true })).optional(),
    planId: __1.ShortStringSchema.uuid(),
    subscriptionId: __1.ShortStringSchema.optional(),
    status: zod_1.z.nativeEnum(__1.ContractStatus),
    paymentStatus: zod_1.z.nativeEnum(__1.PaymentStatus),
    paymentFailureReason: __1.ShortStringSchema.optional(),
    hasPaymentConfigured: zod_1.z.boolean().optional(),
    trialEndsAt: zod_1.z.coerce.date().optional(),
    lastSuccessfulChargeAt: zod_1.z.coerce.date().optional(),
    nextChargeAt: zod_1.z.coerce.date().optional(),
    subscribedAt: zod_1.z.coerce.date(),
    canceledAt: zod_1.z.coerce.date().optional(),
    cancelAtPeriodEnd: zod_1.z.boolean().optional(),
    paymentMethod: zod_1.z.nativeEnum(__1.PaymentMethod).optional(),
    /**
     * @deprecated
     */
    subscriptionStatus: zod_1.z.nativeEnum(__1.SubscriptionStatus).optional(),
    price: _1.PlanPriceSchema.or(__1.MoneySchema),
    totalPrice: _1.PlanTotalPriceSchema.or(__1.MoneySchema),
    discount: _1.SubscriptionDiscountSchema.optional(),
    /**
     * Slip details
     * only if plan allowed payments with Boleto
     *
     * When Boleto is paid, the slip details should be removed from the contract
     */
    slip: exports.slipSchema.optional(),
    /**
     * Pix QR Code details
     * only if plan allowed payments with Pix
     *
     * When Pix is paid, the pix details should be removed from the contract
     */
    pixQRCode: exports.pixQRCodeSchema.optional(),
    planType: zod_1.z.nativeEnum(_1.PlanType),
    /**
     * 3D Secure URL
     * only if bank authentication is required
     *
     * Only returned on checkout when the bank requires 3D Secure authentication
     */
    return3DSecureUrl: zod_1.z.string().url().optional(),
    provider: zod_1.z.nativeEnum(__1.PlanProvider).optional(),
    partnerId: __1.ShortStringSchema.uuid().optional(),
    distributorId: __1.ShortStringSchema.uuid().optional(),
    licenseId: __1.ShortStringSchema.uuid().optional(),
}).omit({
    bulletPoints: true,
    highlight: true,
    active: true,
    position: true,
    prices: true,
    totalPrices: true,
    discounts: true,
    type: true,
    providers: true,
    level: true,
});
exports.ContractWithoutStoreSchema = exports.ContractSchema.omit({ store: true });
//# sourceMappingURL=contract.js.map